var map = {
	"./Stroke 1.png": 2393,
	"./Why Our Save the Dat.png": 2394,
	"./all_about_shipping@2x.png": 2395,
	"./ask_for_everything@2x.png": 2396,
	"./big-day@1x.png": 2397,
	"./big-day@2x.png": 2398,
	"./birds@1x.png": 2399,
	"./birds@2x.png": 2400,
	"./check-list@1x.png": 2401,
	"./check-list@2x.png": 2402,
	"./circle-better@1x.png": 2403,
	"./circle-better@2x.png": 2404,
	"./empty_rsvp.png": 2405,
	"./empty_rsvp2x.png": 2406,
	"./envelope.png": 906,
	"./envelope.svg": 2407,
	"./envelope@2x.png": 2408,
	"./events_doodle.png": 787,
	"./events_doodle.svg": 2409,
	"./gifts@1x.png": 2410,
	"./gifts@2x.png": 2411,
	"./guest-list@1x.png": 2412,
	"./guest-list@2x.png": 2413,
	"./guest.png": 2414,
	"./guest.svg": 2415,
	"./guest2x.png": 2416,
	"./guest_approved@2x.png": 2417,
	"./invitations@1x.png": 2418,
	"./invitations@2x.png": 2419,
	"./invites_paper.svg": 2420,
	"./invites_paper@1x.png": 2421,
	"./invites_paper@2x.png": 2422,
	"./laptop-one-heart.png": 2423,
	"./laptop-one-heart@2x.png": 2424,
	"./laptop@1x.png": 2425,
	"./laptop@2x.png": 2426,
	"./long-page-checklist.png": 2427,
	"./long-page-checklist@2x.png": 2428,
	"./make_it_personal@2x.png": 2429,
	"./namecard-with-name.png": 2430,
	"./namecard-with-name@2x.png": 2431,
	"./namecard_no_name.svg": 788,
	"./namecard_with_name.svg": 2432,
	"./namecard_with_question_marks.svg": 422,
	"./no_address.png": 2433,
	"./no_address2x.png": 2434,
	"./onboarding_1.png": 2435,
	"./onboarding_1@2x.png": 2436,
	"./onboarding_2.png": 2437,
	"./onboarding_2@2x.png": 2438,
	"./onboarding_3.png": 2439,
	"./onboarding_3@2x.png": 2440,
	"./onboarding_4.png": 2441,
	"./onboarding_4@2x.png": 2442,
	"./red-star-left@1x.png": 2443,
	"./red-star-left@2x.png": 2444,
	"./red-star-right@1x.png": 2445,
	"./red-star-right@2x.png": 2446,
	"./registry_publish_champagne.svg": 2447,
	"./rsvp@1x.png": 2448,
	"./rsvp@2x.png": 2449,
	"./save-the-date@1x.png": 2450,
	"./save-the-date@2x.png": 2451,
	"./sparkle-left.svg": 855,
	"./sparkle-right.svg": 856,
	"./sparkle-up.svg": 913,
	"./ta-da.png": 2452,
	"./ta-da@2x.png": 2453,
	"./talk.svg": 2454,
	"./talk@1x.png": 857,
	"./talk@2x.png": 858,
	"./timeline-line-dark@1x.png": 2455,
	"./timeline-line-dark@2x.png": 2456,
	"./timeline-line@1x.png": 2457,
	"./timeline-line@2x.png": 2458,
	"./tips.svg": 676,
	"./underline_long@1x.png": 2459,
	"./underline_long@2x.png": 2460,
	"./underline_sm@1x.png": 2461,
	"./underline_sm@2x.png": 2462,
	"./website_publish_confetti.svg": 789,
	"./wedding-websites@1x.png": 2463,
	"./wedding-websites@2x.png": 2464,
	"./wedding_help.png": 914,
	"./wedding_help.svg": 2465,
	"./wedding_help@2x.png": 2466
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 438;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 438
// module chunks = 51